import React from "react";
import './InfoMarket.css';



class InfoMarket extends React.Component{
    render() {
        return (
            <div>
                <h2>Валютный рынок</h2>
        <p>Валютный рынок (также Фо́рекс от англ. Foreign Exchange — «зарубежный обмен», иногда FX) — это система устойчивых экономических и организационных отношений, возникающих при осуществлении операций по покупке или продаже иностранной валюты, платежных документов в иностранных валютах, а также операций по движению капитала иностранных инвесторов.</p>
            <p>На валютном рынке происходит согласование интересов инвесторов, продавцов и покупателей валютных ценностей. Западные экономисты характеризуют валютный рынок с организационно-технической точки зрения как совокупную сеть современных средств связи, соединяющих национальные и иностранные банки и брокерские фирмы.</p>

                <p>Операции на рынке форекс по целям могут быть торговыми, спекулятивными, хеджирующими и регулирующими (валютные интервенции центробанков).</p>

    <h3>Cтановления валютного рынка</h3>
        <p>Операции по обмену валют существовали ещё в древнем мире и в средние века. Однако современные валютные рынки возникли в XIX веке. Основными предпосылками, способствовавшими становлению валютного рынка в современном понимании явились следующие:</p>

    <ul>
   <li><p> широкое развитие различных международных экономических связей;</p></li>
    <li><p>создание мировой валютной системы, основанной на организации и регулировании валютных отношений, закрепленная межгосударственными соглашениями;</p></li>
   <li><p> широкое распространение кредитных средств международных расчётов и платежей;</p></li>
    <li><p>укрупнение и централизация банковского капитала, широкое развитие корреспондентских отношений между банками разных стран, включающих ведение корреспондентских счетов в иностранной валюте;</p></li>
    <li><p>развитие информационных технологий и средств связи: телеграфа, телефона, телекса, что упростило контакты между валютными рынками и сократило время на получение информации о совершённых сделках.</p></li>
    <li><p>Развивающиеся национальные валютные рынки и их взаимодействие сформировали единый мировой валютный рынок, на котором стали свободно обращаться ведущие валюты в мировых финансовых центрах.</p></li>
    </ul>
            </div>
        );
    }
}
export default InfoMarket;